export default "__VITE_ASSET__h6vDXEU6__"